import { render, staticRenderFns } from "./FabricSelect.vue?vue&type=template&id=ca4f9412"
import script from "./FabricSelect.vue?vue&type=script&lang=js"
export * from "./FabricSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports